
import { Component, Vue, Watch } from 'vue-property-decorator';
import isImageSizeValid from '@/util/is-image-size-valid';
import SingleImageUpload from '@/component/single-image-upload.vue';
import MultipleImageUpload from '@/component/multiple-image-upload.vue';
import { UPLOAD_DIR } from '@/constants';
const { VUE_APP_FCAPI: FCAPI } = process.env;
const API = {
  sample: `${FCAPI}/boss/ruan/sample`,
  community: `${FCAPI}/boss/ruan/community/name`,
};
@Component({
  components: {
    SingleImageUpload,
    MultipleImageUpload,
  },
})
export default class RuanSampleRoomDetail extends Vue {
  is_loading = false;
  UPLOAD_DIR = UPLOAD_DIR;
  is_new = false;
  form_item_layout = {
    labelCol: { span: 2 },
    wrapperCol: { span: 22 },
  };
  form: any = {
    name: {
      number: 20,
    },
    community: {
      data: '',
    },
    list_image: {
      data: '',
    },
    detail_image: {
      data: [],
    },
    detail_url: {
      data: '',
    },
    radio_value: 1,
  };
  community_list = [];
  preview_image = '';
  preview_visible = false;
  send_data = {};

  get id(): number {
    const id = Number(this.$route.params.id);
    if (Number.isNaN(id)) {
      return 0;
    }
    return id;
  }
  get isNew() {
    return this.id === 0;
  }

  @Watch('form.list_image.data')
  onChangeListImg() {
    this.checkChange('list_image');
  }

  handlePreview(imageUrl: string) {
    this.preview_image = imageUrl;
    this.preview_visible = true;
  }

  handlePreviewCancel() {
    this.preview_visible = false;
  }

  beforeListImgUpload(file: any) {
    if (file.size / 1024 > 2048) {
      this.$message.error('图片过大，请上传 2M 以内图片');
      return false;
    }
    return isImageSizeValid(
      file,
      (width: number, height: number) => width === 670 && height === 313
    ).catch((data: any) => {
      const { width, height } = data;
      this.$message.error(
        `图片宽高限定 670*313px，当前上传图片宽高为 ${width}*${height}`
      );
      return Promise.reject(null);
    });
  }

  checkChange(field: any) {
    let error = '0';
    if (field === 'name') {
      if (!this.form.name.data) {
        this.form.name.status = 'error';
        this.form.name.error = '请输入案例名称';
        error = '1';
      } else {
        this.form.name.status = '';
        this.form.name.error = '';
      }
      if (this.form.name.data) {
        this.form.name.number =
          this.form.name.data && this.form.name.data.length > 20
            ? 0
            : 20 - this.form.name.data.length;
        if (this.form.name.data.length > 20) {
          this.form.name.status = 'error';
          this.form.name.error = '套餐名称最多20个字';
          error = '1';
        } else {
          this.form.name.status = '';
          this.form.name.error = '';
        }
      } else {
        this.form.name.number = 20;
      }
      return error;
    } else if (field === 'community') {
      if (!this.form.community.data) {
        this.form.community.status = 'error';
        this.form.community.error = '请选择所属小区';
        error = '1';
      } else {
        this.form.community.status = '';
        this.form.community.error = '';
      }
      return error;
    } else if (field === 'list_image') {
      if (!this.form.list_image.data) {
        this.form.list_image.status = 'error';
        this.form.list_image.error = '请上传列表图';
        error = '1';
      } else {
        this.form.list_image.status = '';
        this.form.list_image.error = '';
      }
      return error;
    } else if (field === 'detail_image' && this.form.radio_value === 0) {
      if (this.form.detail_image.data.length <= 0) {
        console.log('jajjajaja');
        this.form.detail_image.status = 'error';
        this.form.detail_image.error = '请上传详情图';
        error = '1';
      } else {
        this.form.detail_image.status = '';
        this.form.detail_image.error = '';
      }
      return error;
    } else if (field === 'detail_image' && this.form.radio_value === 1) {
      if (!this.form.detail_url.data) {
        this.form.detail_image.status = 'error';
        this.form.detail_image.error = '请填写VR链接';
        error = '1';
      } else {
        this.form.detail_image.status = '';
        this.form.detail_image.error = '';
      }
      return error;
    }
    return error;
  }

  validator() {
    let is_valid = true;
    const valid = [];
    for (const key in this.form) {
      if (key) {
        valid.push(this.checkChange(key));
      }
    }
    this.$forceUpdate();
    if (valid.indexOf('1') !== -1) {
      is_valid = false;
    }
    return is_valid;
  }

  sendData() {
    const form = this.form;
    const send_data = {
      name: form.name.data,
      community_id: form.community.data,
      list_img_url: form.list_image.data,
      detail_img_url: form.detail_image.data.join(','),
      detail_type: form.radio_value,
      detail_url: form.detail_url.data,
    };
    this.send_data = send_data;
  }

  changeRadio() {
    this.form.detail_url.status = '';
    this.form.detail_image.error = '';
    this.form.detail_image.status = '';
    this.form.detail_url.error = '';
    if (this.form.radio_value === 1) {
      this.form.detail_image = {
        data: [],
      };
    } else {
      this.form.detail_url.data = '';
    }
  }

  submit() {
    if (!this.validator()) {
      return;
    }
    if (this.isNew) {
      this.add();
    } else {
      this.edit();
    }
  }

  async add() {
    this.sendData();
    const res = await this.$axios.post(API.sample, this.send_data);
    if (res.data.status !== 200) {
      this.$message.error(res.data.message);
      return;
    }
    this.$message.success('新增成功');
    this.$router.push({
      path: '/ruan/sample-room-list',
    });
  }

  async edit() {
    this.sendData();
    const res = await this.$axios.put(
      `${API.sample}/${this.id}`,
      this.send_data
    );
    if (res.data.status !== 200) {
      this.$message.error(res.data.message);
      return;
    }
    this.$message.success('编辑成功');
    this.$router.push({
      path: '/ruan/sample-room-list',
    });
  }

  async query() {
    const res = await this.$axios.get(`${API.sample}/${this.id}/edit`);
    if (res.data.status !== 200) {
      return;
    }
    const data = res.data.data || {};
    const form = this.form;
    form.name.data = data.name;
    form.community.data = data.community_id;
    form.list_image.data = data.list_img_url;
    form.detail_image.data = data.detail_img_url
      ? data.detail_img_url.split(',')
      : [];
    form.radio_value = data.detail_type;
    form.detail_url.data = data.detail_url;
  }

  async getCommunity() {
    const res = await this.$axios.get(API.community);
    if (res.data.status !== 200) {
      return;
    }
    const data = res.data.data || {};
    this.community_list = data;
  }

  async created() {
    await this.getCommunity();
    if (!this.isNew) {
      await this.query();
    }
  }
}
